// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3AuVe","filesListContainer":"PosDisputesFiles_filesListContainer__3Wiw4","filesButton":"PosDisputesFiles_filesButton__137UE"};